import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  customTool: {
    marginLeft: '13px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    cursor: 'pointer',
    marginTop: '10px'
  },
  dialogTitle: {
    lineHeight: '2 !important',
    padding: '8px 10px !important',
  },
  dialogModal: {
    '& .MuiPaper-root': {
      marginLeft: '10px',
      '& .makeStyles-dialogTitle-37': {
        padding: '16px 12px !important',
      },
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    },
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '10px',
    fontSize: '18px',
    cursor: 'pointer'
  },
  legendItemMobile: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '10px',
    fontSize: '14px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  inputField: {
    width: '100%'
  },
  headerCell: {
    border: '1px solid grey',
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 'bold',
    padding: '4px',
    height: '20px'
  },
  rowCell: {
    border: '1px solid grey',
    backgroundColor: 'white',
    color: 'black',
    padding: '4px',
    height: '20px'
  },
  tableContainer: {
    maxWidth: 600,
    height: 'auto',
    maxHeight: 730
  },
  menuTogglerBtn: {
    position: 'absolute',
    bottom: '38vh',
    zIndex: 200,
    right: '-20px',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#c3c3c3',
    },
  },
  menuTogglerTableBtn: {
    position: 'absolute',
    bottom: '38vh',
    zIndex: 200,
    right: '35%',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#c3c3c3',
    },
  },
  menuTogglerMobileBtn: {
    position: 'absolute',
    bottom: '38vh',
    zIndex: 200,
    right: '-10px',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
  },
  menuTogglerMobileTableBtn: {
    position: 'absolute',
    bottom: '38vh',
    zIndex: 200,
    right: '-10px',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
  },
  editBox: {
    border: '1px solid grey',
    borderRadius: 1
  },
  xAxisEditBtn: {
    position: 'absolute',
    top: -33,
    left: '24px'
  },
  yAxisEditBtn: {
    position: 'absolute',
    top: -65,
    left: '-8px'
  },
  resultSummary: {
    justifyItems: 'left',
    padding: '6px',
    border: '1px solid',
    borderRadius: '2px',
  },
  resultSummaryText: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1.4
  },
  resultSummaryTextMobile: {
    fontSize: '14px',
    fontWeight: 'bold',
    lineHeight: 2
  },
  gridContainer: {
    paddingTop: '4px',
    borderBottom: '1px solid #ccc'
  },
  gridItem: {
    background: '#F2F2F2',
    paddingBottom: '1px',
    borderBottom: '0.5px solid #FFF',
    textAlign: 'center'
  },
  headerName: {
    flex: 0.5,
    fontWeight: 'bold',
    borderRight: '1px solid #ccc'
  },
  accordianScrollUp: {
    position: 'fixed',
    bottom: 10,
    right: 10
  },
}));
export default styles;
